export default "__VITE_ASSET__CIQ$ZLb1__"